/* eslint-disable no-underscore-dangle,class-methods-use-this */
import { action, observable } from 'mobx';
import { createContext } from 'react';
import { I18N_FALLBACK_LANG } from '@/utils/const';
import { UserInfo, TeamListData, OpensceneData } from '@/typings/common';
import { getOpenSceneList, getTeamList } from '@/server/common';
import errCode from '@/utils/request/errCode';
import { get } from 'lodash';
import { getQueryParams } from '@/utils/common';
import Message from '@/component/Message';
import i18next from 'i18next';

const getLang = () => window.localStorage.getItem('_lang_');

const teamId = getQueryParams('team_id');

const opensceneId = getQueryParams('openscene_id');

const defaultTeamData = {
  id: '',
  name: '',
  logo: '',
  description: '',
  createTime: '',
  role: 'enterprise_anonymous',
  superAdminList: [],
};

const defaultOpenscene = {
  id: '',
  name: '',
  logo: '',
  server: '',
  description: '',
  createTime: '',
  prefix: '',
  role: 'enterprise_anonymous',
  superAdminList: [],
};

class GlobalInfoStore {
  @observable loading = false;

  @observable user: UserInfo = {} as UserInfo;

  @observable lng = getLang() || 'zh' || I18N_FALLBACK_LANG;

  @observable teamList: TeamListData[] = [];

  @observable hasTeamList = true;

  @observable openSceneList: OpensceneData[] = [];

  @observable hasSceneList = true;

  @observable activeTeamId = '';

  @observable activeOpensceneId = '';

  @observable teamPageInfo = {
    page: 1,
    pageSize: 20,
    totalNumber: 0,
    totalPage: 1,
  };

  @observable activeTeamInfo: TeamListData = { ...defaultTeamData };

  @observable activeOpensceneInfo: OpensceneData = { ...defaultOpenscene };

  @action
  setUser(user: UserInfo) {
    this.user = user;
  }

  @action
  async getOpenSceneList() {
    const result = await getOpenSceneList({
      openSceneId: opensceneId,
      pageSize: 50,
    });
    if (result.code !== errCode.SUCCESS) {
      return Promise.resolve('error');
    }
    this.openSceneList = get(result, 'data.list', []);
    this.hasSceneList = this.openSceneList.length !== 0;
    this.activeOpensceneId = opensceneId || (this.openSceneList.length > 0 ? this.openSceneList[0].id : '');
    this.activeOpensceneInfo = opensceneId
      ? get(result, 'data.item', { ...defaultOpenscene })
      : this.openSceneList[0];
    // 如果不存在 item 说明当前id的 scene 是不存在的
    if (opensceneId && !get(result, 'data.item')) {
      Message.error(i18next.t('scene_unexist'));
      return Promise.resolve('error');
    }
    return Promise.resolve('success');
  }

  @action
  async getTeamList() {
    const result = await getTeamList({
      teamId,
      page: this.teamPageInfo.page,
      pageSize: this.teamPageInfo.pageSize,
    });
    if (result.code !== errCode.SUCCESS) {
      return Promise.resolve('error');
    }
    this.teamPageInfo = get(result, 'data.pageInfo', this.teamPageInfo);
    this.teamList = get(result, 'data.list', []);
    this.hasTeamList = this.teamList.length !== 0;
    this.activeTeamId = teamId || (this.teamList.length > 0 ? this.teamList[0].id : '');
    this.activeTeamInfo = teamId
      ? get(result, 'data.item', { ...defaultTeamData })
      : this.teamList[0];
    // 如果不存在 item 说明当前id的 team 是不存在的
    if (teamId && !get(result, 'data.item')) {
      Message.error(i18next.t('team_unexist'));
      return Promise.resolve('error');
    }

    return Promise.resolve('success');
  }
}

export const globalInfoStore = new GlobalInfoStore();
export const globalInfoStoreContext = createContext(globalInfoStore);
